import type { CompanyFormDto } from '@/routes/admin-v2/master/company/-components/dto'

import { formatDateTimeServer } from '@/lib/utils/utils'

import { apiClient } from '../rest/http'

export async function jobCompanyApiUpsert(
  data: CompanyFormDto,
  meta?: { id: number; created_at: string }
) {
  const formData = new FormData()
  // Update
  if (meta) {
    formData.set('id', String(meta.id))
    formData.set('created_at', formatDateTimeServer(new Date(meta.created_at)))
  }

  if (data.logo) {
    formData.set('logo', data.logo)
  }

  formData.set('name', data.name)
  formData.set('size_from', String(data.size_from))
  formData.set('size_to', String(data.size_to))

  const res = await apiClient.post('/api/job/company/upsert', formData)
  return res.data
}
